import { render, staticRenderFns } from "./LandingContentMain.vue?vue&type=template&id=49047abd&scoped=true"
var script = {}
import style0 from "./LandingContentMain.vue?vue&type=style&index=0&id=49047abd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49047abd",
  null
  
)

export default component.exports